/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="17.74"
        viewBox="0 0 19 17.74"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.52 2.15a7.8 7.8 0 1 1-7.8 7.8 7.8 7.8 0 0 1 7.8-7.8Zm0 1a6.8 6.8 0 1 0 6.79 6.8 6.82 6.82 0 0 0-6.79-6.8Zm-.9 2.42h1V9.8h4.79v1h-5.8ZM3.85.19a3.91 3.91 0 0 1 4.09 1.3l.1.11-.77.64-.1-.11a3.07 3.07 0 0 0-.77-.67 3 3 0 0 0-2.32-.29 4.25 4.25 0 0 0-2.6 1.88 3.3 3.3 0 0 0 .43 4l.1.11-.71.7-.1-.11a4.27 4.27 0 0 1-.57-5.21A5.23 5.23 0 0 1 3.85.19Zm7.24 1.3a4.11 4.11 0 0 1 4.3-1.33 4.93 4.93 0 0 1 3 2.39 4.36 4.36 0 0 1-.59 5.2l-.1.11-.71-.7.12-.11a3.39 3.39 0 0 0 .42-4 3.9 3.9 0 0 0-2.4-1.9 3.1 3.1 0 0 0-3.29 1l-.1.11-.76-.64Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'AlarmClockIcon';

export default Icon;
